
<template>
  <div>
    <v-btn color="blue-grey" rounded class="white--text font-weight-bold py-5" @click="getPdf()">
      <div class="d-flex flex-column ma-2 pa-2">
        <div class="d-flex align-center">
          <v-icon left>mdi-file-chart-outline</v-icon>
          <span>Relatório</span>
        </div>
        <div class="text-caption text-grey">
          Últimos 3 meses
        </div>
      </div>
    </v-btn>
  </div>
</template>

<script>
import Api from '@/api/index';
import { mapState } from 'vuex';

export default {
  name: 'PrintTransactionsHistory',
  props: {
    type_tabs: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    model_type_tabs() {
      return "Driver"
    },
    ...mapState({
      oneDriver: state => state.Driver.oneDriver,
    }),
  },
  methods: {
    getFilter() {
      let id = this.$route.params.id
      let filter = {
        id,
        modality_id: this.activeModalityId,
        destinable_type: this.model_type_tabs,
        destinable_id: this.oneDriver.data.id
      }
      return filter
    },
    getPdf() {
      let id = this.$route.params.id
      let filter = this.getFilter()
      Api.Driver.getHistoryPaymentsPdf(filter).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `motorista_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link.href)
      }).catch(error => {
        console.error({ error })
      })
    },
  },
}
</script>